import React from 'react';
import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { DatePickerProps } from './types';

export const DateTimePicker: React.FC<DatePickerProps> = ({
  label,
  value,
  disabled,
  error,
  placement,
  onChange,
}) => {
  return (
    <div className="d-flex flex-column date-time-picker">
      <DesktopDateTimePicker
        value={value}
        label={label}
        reduceAnimations
        className="date-picker"
        autoFocus={false}
        disablePast
        PopperProps={{
          popperOptions: {
            placement: placement || 'top-start',
          },
        }}
        renderInput={(params) => (
          <TextField color="primary" variant="outlined" {...params} />
        )}
        disabled={disabled}
        onChange={onChange}
      />
      <span className="error-text">
        {error && (
          <span className="error-text">
            {typeof error === 'object' ? error.join(', ') : error}
          </span>
        )}
      </span>
    </div>
  );
};
